// extracted by mini-css-extract-plugin
module.exports = {"cities-list-container":"CitiesList_cities-list-container__L5chz","city-links-container":"CitiesList_city-links-container__LAedU"};